<template>
  <v-container
    fluid
  >
    <v-form>
      <v-container>
        <v-btn
          class="ma-2 float-left"
          tile
          outlined
          :loading="btnLoading"
          :disabled="btnLoading"
          color="success"
          @click="save()"
        >
          <v-icon
            left
          >
            mdi-check
          </v-icon>
          {{ $t('save') }}
        </v-btn>
        <v-subheader
          class="display-1"
        >
          {{ $t('operations_settings') }}
        </v-subheader>
        <v-card-text>
          <v-row>
            <v-col
              md="12"
            >
              <v-subheader>{{ $t('table_row_count') }}</v-subheader>
              <v-slider
                v-model="UsersCPP"
                class="align-center"
                :max="max"
                :min="min"
                hide-details
              >
                <template
                  v-slot:append
                >
                  <v-text-field
                    v-model="UsersCPP"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                  />
                </template>
              </v-slider>
            </v-col>
            <v-col
              md="12"
            >
              <v-select
                v-model="usersValue"
                :items="usersItems"
                item-text="display"
                item-value="dbitem"
                :label="$t('columns')"
                chips
                dense
                multiple
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-subheader
          class="display-1"
        >
          {{ $t('category_settings') }}
        </v-subheader>
        <v-card-text>
          <v-row>
            <v-col
              md="12"
            >
              <v-subheader>{{ $t('table_row_count') }}</v-subheader>
              <v-slider
                v-model="UsersCategoriesCPP"
                class="align-center"
                :max="max"
                :min="min"
                hide-details
              >
                <template v-slot:append>
                  <v-text-field
                    v-model="UsersCategoriesCPP"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                  />
                </template>
              </v-slider>
            </v-col>
            <v-col
              md="12"
            >
              <v-select
                v-model="usersCategoriesValue"
                :items="usersCategoriesItems"
                item-text="display"
                item-value="dbitem"
                :label="$t('columns')"
                chips
                dense
                multiple
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-container>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  export default {
    name: 'Settings',
    data: () => ({
      btnLoading: false,
      valid: false,
      UsersCPP: 0,
      UsersCategoriesCPP: 0,
      min: 1,
      max: 100,
      usersItems: [],
      usersValue: [],
      usersCategoriesItems: [],
      usersCategoriesValue: [],
      dynamicColumns: [],
      snackbar: false,
      snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
      snackbarText: '',
    }),
    async created () {
      await this.getOptions()
      await this.getDynamicColumns()
      await this.getUsersCategoriesColumns()
    },
    methods: {
      getOptions () {
        this.$http.post('options/showLikeTitle', {
          title: 'Users',
        }).then(
          response => {
            const result = response.data.Option
            this.UsersCPP = parseInt(result.find(x => x.title === 'Users-CPP').value)
            this.UsersCategoriesCPP = parseInt(result.find(x => x.title === 'Users-Categories-CPP').value)
            let tempValue = result.filter(x => x.title === 'Users-TH-Operations')
            let tempArray = []
            tempValue.forEach(function (value) {
              tempArray.push(value.value)
            })
            this.usersValue = tempArray

            tempValue = result.filter(x => x.title === 'Users-TH-Category')
            tempArray = []
            tempValue.forEach(function (value) {
              tempArray.push(value.value)
            })
            this.usersCategoriesValue = tempArray
          },
          error => {
            if (error) {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x917'
              this.snackbar = true
            }
          }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x918'
            this.snackbar = true
          }
        })
      },
      getUsersColumns () {
        this.$http.post('users/columns').then(
          response => {
            const result = response.data.UsersColumns
            const tempArray = []
            const self = this
            result.forEach(function (value) {
              tempArray.push({
                dbitem: value,
                display: self.$t((typeof self.dynamicColumns[value] !== 'undefined') ? self.dynamicColumns[value] : value),
              })
            })
            this.usersItems = tempArray
          },
          error => {
            if (error) {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x920'
              this.snackbar = true
            }
          }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x919'
            this.snackbar = true
          }
        })
      },
      getUsersCategoriesColumns () {
        this.$http.post('userCategories/columns').then(
          response => {
            const result = response.data.UserCategoriesColumns
            const tempArray = []
            const self = this
            result.forEach(function (value) {
              tempArray.push({ dbitem: value, display: self.$t(value) })
            })
            this.usersCategoriesItems = tempArray
          },
          error => {
            if (error) {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x922'
              this.snackbar = true
            }
          }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x921'
            this.snackbar = true
          }
        })
      },
      getDynamicColumns () {
        this.$http.post('dynamicColumns/showByTable', {
          table: 'users',
        }).then(
          response => {
            const result = response.data.DynamicColumns
            result.forEach(o => {
              this.dynamicColumns[o.column] = o.title
            })
            this.getUsersColumns()
          },
          error => {
            if (error) {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x923'
              this.snackbar = true
            }
          }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x924'
            this.snackbar = true
          }
        })
      },
      save () {
        this.btnLoading = true
        const temparray = []
        this.usersValue.forEach(o => {
          temparray.push({ title: 'Users-TH-Operations', value: o, language_id: 1 })
        })
        this.usersCategoriesValue.forEach(o => {
          temparray.push({ title: 'Users-TH-Category', value: o, language_id: 1 })
        })
        this.$http.post('options/destroyAndInsertByTitle', {
          title: ['Users-TH-Operations', 'Users-TH-Category'],
          insertArray: temparray,
        }).then(
          response => {
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_updated')
            this.snackbar = true
          },
          error => {
            if (error) {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x925'
              this.snackbar = true
            }
          }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x926'
            this.snackbar = true
          }
        })
        this.btnLoading = false
        // TODO: Save UsersCategoriesColumns and Other
      },
    },
  }
</script>

<style scoped>

</style>
